<template>
  <div class="user-chat-box bg-light card text-sm">
    <div
      class="card-header bg-dark text-center text-white pa-0"
      @click="toggleCollapse"
    >
      <div class="d-flex align-items-center pa-2">
        <span
          v-if="unread > 0"
          class="badge badge-danger"
        >{{ unread }}</span>
        <p class="flex-grow-1 mb-0">
          💬 ติดต่อเอเจนท์
        </p>
        <i
          id="caret"
          :class="{
            fa: true,
            'fa-caret-down': true,
            'd-flex': true,
            'mr-2': true,
            more: !isChatOpen,
          }"
        />
      </div>
      <marquee
        v-if="hotnews.length > 0"
        id="marquee"
        scrollamount="4"
        class="bg-primary text-white"
      >
        <div
          v-for="text in hotnews"
          class="d-inline-block mx-5"
          v-html="text"
        />
      </marquee>
    </div>
    <div
      id="messageWrapper"
      :class="{ collapse: !isChatOpen }"
    >
      <div
        id="messageContainer"
        class="card-body"
      >
        <button
          :disabled="!is_more"
          class="btn btn-sm border-1 w-100"
          @click="fetchMore"
        >
          โหลดอีก
        </button>
        <user-message
          v-for="message in messages"
          :key="message.id"
          :message="message"
        />
      </div>
      <div class="card-footer p-0">
        <v-textarea
          v-model="typed_message"
          auto-grow
          filled
          full-width
          hide-details
          placeholder="ข้อความ..."
          rows="1"
          style="background: #fefefe"
          type="text"
          @keyup.13="sendMessage"
        >
          <template #append>
            <v-icon
              class="my-3"
              @click="sendMessage"
            >
              mdi-send
            </v-icon>
          </template>
        </v-textarea>
      </div>
      <div
        v-if="is_loading"
        id="messageLoading"
      >
        <v-progress-linear indeterminate />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Echo } from '../../plugins/pusher';
import UserMessage from './message';

export default {
  name: 'UserMessagesList',
  components: {
    UserMessage,
  },
  props: {
    participant: { type: Number, default: null },
  },
  data() {
    return {
      lastMessage: null,
      unread: 0,
      is_more: true,
      is_loading: false,
      typed_message: '',
    };
  },
  computed: {
    ...mapState({
      hotnews: (state) => state.user.hotnews,
      isChatOpen: (state) => state.app.isChatOpen,
      messages: (state) => state.user.messages,
    }),
  },
  watch: {
    messages(n, o) {
      this.triggerScroll();
    },
  },
  created() {},
  mounted() {
    if (this.$store.state.app.isChatOpen) {
      document.getElementById('messageWrapper').classList.remove('collapse');
      document.getElementById('caret').classList.remove('more');
    } else {
      document.getElementById('messageWrapper').classList.add('collapse');
      document.getElementById('caret').classList.add('more');
    }

    Echo.private(`user.${window.appState.user.id}`).listen(
      'message-received',
      (message) => {
        this.$store.commit('user/receivedMessage', {
          message: {
            id: message.id,
            displayClass:
              message.sender_id === this.participant ? 'receive' : 'send',
            actor: message.sender_name,
            created_at: new Date(message.created_at),
            message: message.message,
          },
        });
        if (!this.$store.state.app.isChatOpen) {
          this.unread += 1;
        }
      },
    );
  },
  methods: {
    triggerScroll() {
      const container = document.getElementById('messageContainer');
      setTimeout(() => {
        container.scrollTop = container.scrollHeight;
      }, 800);
    },
    fetchMore() {
      this.is_loading = true;
      axios
        .post(`/api/messages/with/${this.participant}`, {
          lastMessage: this.lastMessage,
        })
        .then((response) => {
          const newMessages = response.data.map((message) => ({
            id: message.id,
            displayClass:
                message.sender_id == this.participant ? 'receive' : 'send',
            actor: message.sender_name,
            created_at: new Date(message.created_at),
            message: message.message,
          }));
          this.is_more = newMessages.length > 0;
          this.$store.commit('user/receivedMessage', { message: newMessages });
          this.lastMessage = this.messages.length > 0 ? this.messages[0].created_at : new Date();
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    toggleCollapse(event) {
      if (
        document.getElementById('messageWrapper').classList.contains('collapse')
      ) {
        this.unread = 0;
        const container = document.getElementById('messageContainer');
        setTimeout(() => {
          container.scrollTop = container.scrollHeight;
        }, 600);
        this.$store.commit('app/openChat');
      } else {
        this.$store.commit('app/closeChat');
      }
    },
    sendMessage(event) {
      if (this.typed_message.trim().length > 0) {
        this.is_loading = true;
        axios
          .post(`/api/messages/sendto/${this.participant}`, {
            message: this.typed_message,
          })
          .then((response) => {
            if (response.status == 200) {
              const res_message = response.data;
         
              const payload = {
                message: {
                  id: res_message.id,
                  displayClass: 'send',
                  actor: res_message.sender_name,
                  created_at: new Date(res_message.created_at),
                  message: res_message.message,
                },
              };
         
              this.$store.commit('user/receivedMessage', payload);
            }
          })
          .catch((e) => console.log(e))
          .finally(() => {
            this.typed_message = '';
            this.is_loading = false;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.user-chat-box {
  bottom: -1px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;
  display: block;
  position: fixed;
  width: 300px;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (min-width: 768px) {
    left: unset;
    transform: unset;
    right: 0;
    margin-right: 20px;
  }

  .card-header {
    cursor: pointer;
  }

  .card-body {
    height: 400px;
    max-height: 40vh;
    overflow-y: scroll;
  }
}
#caret {
  transition: all 0.4s;
  &.more {
    transform: rotate(180deg);
  }
}
#messageContainer {
  transition: all 0.3;
  scroll-behavior: smooth;
}
#messageWrapper {
  position: relative;
}
#messageLoading {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
}
#marquee {
  margin-bottom: -5px;
}
</style>
